module.exports = __webpack_public_path__ + "static/img/company1.44eb34b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/index/company1.png
// module id = 9wjF
// module chunks = 1